<template>
  <div class="scroll-top" @click="scrollToTop" :style="style">
  </div>
</template>
<script>
export default {
  data () {
    return {
      style: {
        opacity: 0.9
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    handleScroll (e) {
      this.style.opacity = e.target.scrollingElement.scrollTop > 100 ? 0.5 : 0.9
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style lang="scss" scoped>
  .scroll-top {
    position: fixed;
    bottom: 20vh;
    right: 5px;
    width: 0.7rem;
    height: 0.7rem;
    background: #fff;
    background-image: url("../../assets/icon/up.svg") ;
    background-repeat: no-repeat;
    background-position: 50%;
    border-radius: 50%;
    background-size: 50%;
  }
</style>